<template>
    <a-modal title="服务商代理合同" :width="1200" :open="true" @cancel="cancel" :maskClosable="false">
        <template #footer>
            <a-button @click="cancel">取消</a-button>
            <a-popconfirm title="是否确定？" @confirm="onFormSubmit">
                <a-button type="primary" :loading="state.submitLoading">确定</a-button>
            </a-popconfirm>
        </template>
        <a-skeleton :loading="state.loading" active :paragraph="{ rows: 10 }">
            <a-form ref="ruleForm" :model="formData" v-bind="formLayout">
                <a-form-item label="甲方公司" name="fws_ptid" required>
                    <a-select v-model:value="formData.fws_ptid" placeholder="请选择">
                        <a-select-option :value="1">长沙发财人财务有限公司</a-select-option>
                        <a-select-option :value="2">西安明之楷企业服务有限公司</a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item label="乙方公司" name="company_name" required>
                    <a-input v-model:value="formData.company_name" placeholder="请输入乙方公司名称"></a-input>
                </a-form-item>
                <a-form-item label="乙方社会信用代码" name="social_credit_code" required>
                    <a-input v-model:value="formData.social_credit_code" placeholder="请输入乙方社会信用代码"></a-input>
                </a-form-item>
                <a-form-item label="乙方开户行账户名称" name="bank_from">
                    <a-input v-model:value="formData.bank_from" placeholder="请输入乙方开户行账户名称"></a-input>
                </a-form-item>
                <a-form-item label="乙方开户行账号" name="social_credit_code">
                    <a-input v-model:value="formData.bank_idcard_num" placeholder="请输入乙方开户行账号"></a-input>
                </a-form-item>
                <a-form-item label="乙方执照注册地址" name="address">
                    <a-input v-model:value="formData.address" placeholder="请输入乙方执照注册地址"></a-input>
                </a-form-item>
                <a-form-item label="营业执照" name="business_license_urls" required>
                    <Upload :upload_path="`public/uploads/manage/财务管理/服务商代理合同/${dayjs().format('YYYYMM')}/`"
                        :accept="['pdf', 'jpeg', 'jpg', 'png']" uploadType="text"
                        v-model:value="formData.business_license_urls" :limitation="99" uploadText="上传营业执照">
                    </Upload>
                </a-form-item>
                <a-form-item label="合同" name="attachment" required>
                    <Upload :upload_path="`public/uploads/manage/财务管理/服务商代理合同/${dayjs().format('YYYYMM')}/`"
                        :accept="['pdf', 'doc', 'docx', 'jpeg', 'jpg', 'png']" uploadType="text"
                        v-model:value="formData.attachment" :limitation="99" uploadText="上传合同">
                    </Upload>
                    <a @click="dowloadHetongTp">下载模板</a>
                </a-form-item>
                <a-form-item label="乙方签订人姓名" name="finance_user_name" required>
                    <a-input v-model:value="formData.finance_user_name" placeholder="请输入乙方签订人姓名"></a-input>
                </a-form-item>
                <a-form-item label="乙方签订人手机号" name="finance_phone" required>
                    <a-input @change="
                        (v) => {
                            phoneChange(formData.finance_phone, 'finance_phone')
                        }
                    " v-model:value="formData.finance_phone" placeholder="请输入乙方签订人手机号" has-feedback
                        :validate-status="checkdatastate.finance_phone"></a-input>
                </a-form-item>
            </a-form>
        </a-skeleton>
    </a-modal>
</template>

<script lang="ts" setup>
import { message, Modal } from 'ant-design-vue'
import baseService from '@/utils/http/axios'
import baseServicePlus from '@/utils/http/axiosPlus'
import { reactive, onMounted, ref, onUnmounted } from 'vue'
import Upload from '@/components/base/Upload.vue'
import dayjs from 'dayjs'
const formLayout = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 6 }
    },
    wrapperCol: {
        xs: { span: 24 },
        sm: { span: 10 }
    }
}
const checkdatastate = reactive<any>({})
const ruleForm = ref()
const emit = defineEmits(['cancel', 'ok'])
const props = defineProps({
    detailData: {
        type: Object,
        default: () => { }
    }
})
interface intervalList {
    timer: any
    time: number
}
interface IState {
    loading: boolean
    modalTitle: string
    submitLoading: boolean
    intervalList: intervalList[]
}
const state = reactive<IState>({
    loading: false,
    modalTitle: '新增',
    submitLoading: false,
    intervalList: [],
})
interface IformData {
    fws_ptid: number,//甲方
    company_name: string,//乙方公司
    social_credit_code: string,//乙方社会信用代码
    business_license_urls: string[],//营业执照
    attachment: string[],//合同
    finance_user_name: string,//乙方签订人
    finance_phone: string,//乙方签订人手机号
    from_customer_id: number
    address: string
    bank_idcard_num: string
    bank_from: string
}
const formData = reactive<IformData>({
    fws_ptid: 2,//甲方,默认明之楷
    company_name: '',//乙方公司
    social_credit_code: '',//乙方社会信用代码
    business_license_urls: [],//营业执照
    attachment: [],//合同
    finance_user_name: '',//乙方签订人
    finance_phone: '',//乙方签订人手机号
    from_customer_id: 0,
    address: '',
    bank_idcard_num: '',
    bank_from: '',
})
onMounted(() => {
    if (props.detailData?.id) {
        state.modalTitle = '编辑'
        queryDetail()
    } else if (props.detailData?.customer_id && props.detailData?.company_name) {
        formData.company_name = props.detailData.company_name
        formData.from_customer_id = props.detailData.customer_id
        queryFwsPtid()
    }
})
onUnmounted(() => {
    state.intervalList.forEach((item) => {
        clearInterval(item.timer)
    })
})
const queryDetail = () => {
    state.loading = true
    let requeryParam = {
        url: `/admin/v1/fwsdailihetong/${props.detailData.id}/edit`,
        method: 'get'
    }
    baseService(requeryParam)
        .then((res) => {
            Object.assign(formData, res.data)
        })
        .finally(() => {
            state.loading = false
        })
}
const queryFwsPtid = () => {
    state.loading = true
    let requestParam = {
        url: '/admin/v1/busstype/getfwsptid',
        method: 'post',
        data: {
            'customer_id': formData.from_customer_id
        }
    }
    baseService(requestParam)
        .then((res: any) => {
            formData.fws_ptid = res.data
        })
        .catch((res) => {
            if (res.msg) {
                message.error(res.msg)
            } else {
                message.error('操作失败,请联系管理员')
            }
        })
        .finally(() => {
            state.loading = false
        })
}
// 提交
const onFormSubmit = () => {
    ruleForm.value
        .validate()
        .then(() => {
            state.loading = true
            if (props.detailData?.id > 0) {
                let requeryParam = {
                    url: '/admin/v1/fwsdailihetong/' + props.detailData.id,
                    method: 'put',
                    data: formData
                }
                baseService(requeryParam)
                    .then((res: any) => {
                        state.loading = false
                        message.success(res.msg)
                        emit('ok')
                    })
                    .catch((res) => {
                        state.loading = false
                        if (res.msg) {
                            message.error(res.msg)
                        } else {
                            message.error('操作失败')
                        }
                    })
            } else {
                let requeryParam = {
                    url: '/admin/v1/fwsdailihetong',
                    method: 'post',
                    data: formData
                }
                baseService(requeryParam)
                    .then((res: any) => {
                        state.loading = false
                        message.success(res.msg)
                        emit('ok')
                    })
                    .catch((res) => {
                        state.loading = false
                        if (res.msg) {
                            message.error(res.msg)
                        } else {
                            message.error('操作失败')
                        }
                    })
            }
        })
        .catch(() => { })
}
const cancel = () => {
    emit('cancel')
}
//下载合同模板
const dowloadHetongTp = () => {
    if (!formData.fws_ptid) {
        message.error('请先选择甲方')
        return
    }
    if (!formData.company_name) {
        message.error('请先填写乙方公司')
        return
    }
    if (!formData.social_credit_code) {
        message.error('请先填写乙方社会信用代码')
        return
    }
    //如果 formData.finance_user_name 为空，则返回错误提示
    if (!formData.finance_user_name) {
        message.error('请先填写乙方签订人姓名')
        return
    }

    //如果 formData.finance_user_phone 为空，则返回错误提示
    if (!formData.finance_phone) {
        message.error('请先填写乙方签订人手机号')
        return
    }
    //去转换下载模板
    let intervalObj = <intervalList>{
        timer: null,
        time: 5000
    }
    state.intervalList.push(intervalObj)
    const hide = message.loading({
        content: '操作中,请稍等',
        duration: 0,
        class: 'loading-message'
    })
    let requestParam = {
        url: '/admin/v1/fwsdailihetong/downloadtp',
        method: 'post',
        data: {
            fws_ptid: formData.fws_ptid,
            company_name: formData.company_name,
            social_credit_code: formData.social_credit_code,
            from_customer_id: formData.from_customer_id,
            finance_user_name: formData.finance_user_name,
            finance_phone: formData.finance_phone
        }
    }
    baseServicePlus(requestParam, intervalObj)
        .then((res: any) => {
            //直接去下载url
            let requestParam = {
                url: '/admin/v1/fwsdailihetong/downloadtp',
                method: 'post',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    responseType: 'blob'
                },
                data: {
                    axiosStep: 3,
                    url: res.data.url
                }
            }
            baseService(requestParam)
                .then((res) => {
                    message.success('下载成功')
                })
                .catch((res) => {
                    if (res.msg) {
                        message.error(res.msg)
                    } else {
                        message.error('下载失败')
                    }
                })
        })
        .catch((res) => {
            message.error(res.msg)
        })
        .finally(() => {
            setTimeout(hide, 0)
        })
}
const phoneChange = (v, type) => {
    let str = v.replaceAll(/\D/g, '')
    //判断str是不是手机号码
    if (!/^1[23456789]\d{9}$/.test(str)) {
        checkdatastate[type] = 'error'
    } else {
        checkdatastate[type] = 'success'
        formData[type] = str
    }
}
</script>

<style lang="less" scoped></style>
